export const styles = {
  predecessorsCard: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    gap: '16px',
    background: '#FAFBFC',
    borderRadius: '12px',
    marginBottom: '16px',
  },

  predecessorsCardHeader: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },

  title: {
    fontFamily: 'Inter',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: '600',
    lineHeight: '146%',
    color: '#23252F',
  },

  deleteButtonContainer: {
    height: '48px',
    display: 'flex',
    alignItems: 'center',
  },

  deleteButton: {
    width: '20px',
    minWidth: '20px',
    padding: '0',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },

  predecessorsItemName: {
    width: '100%',
    maxWidth: '346px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },

  predecessorsLagDays: {
    width: '100%',
    maxWidth: '139px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },

  predecessorsItemDetails: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '16px',
  },
};
